<div class="content">
  <div *ngIf="loading" class="loading">
    <mat-progress-spinner color="primary" mode="indeterminate" diameter="101">
    </mat-progress-spinner>
  </div>
  <div class="body">
    <div class="header">
    <div *ngIf="compass" class="page-title">{{compass.name}} v{{compass.version}}
      <button mat-icon-button>
        <mat-icon *ngIf="isCopyable()" class="copy-icon" (click)="copy()" svgIcon="copy"></mat-icon>
      </button>
   <div class="provider-name">{{compass.providerName}}</div>  
    </div> 
      <div class="tabs">
        <button mat-button class="body-standard-tab" [ngClass]="{selected: tabIndex == 0}" (click)="setTab(0)">Assignments</button>
        <button mat-button class="body-standard-tab" [ngClass]="{selected: tabIndex == 1}" (click)="setTab(1)">Alerts </button>
        <button mat-button class="body-standard-tab" [ngClass]="{selected: tabIndex == 2}" (click)="setTab(2)">Summary Analysis</button>
      </div>
    </div>

    <div class="search-form" *ngIf="tabIndex === 0">
      <mat-form-field class="search-bar" appearance="outline">
        <button class="search-icon" (click)="search($event)"  matPrefix mat-button><mat-icon>search</mat-icon></button>
        <input matInput (keyup)="checkSearchValue($event)"  (keydown.enter)="search($event)" placeholder="Search for assignments" (input)="searchField = $event.target.value" [value]="searchField">
        <span matSuffix > </span>
      </mat-form-field>
    </div>  
    <div class="patient-list"  *ngIf="tabIndex === 0">
      <div class="patient-list-header">
        <div class="header-title">Assignments
          <p class="hint">Assignments with a recommendation of incomplete typically have tracking data but no assessment results.</p>
        </div>
        <mat-paginator [pageSizeOptions]="[10, 25, 50]"
            showFirstLastButtons 
            aria-label="Select page of assignments"
            (page)="pageAssignmentList($event)"
            [length]="getNumberOfAssignments()"
            [pageIndex]="getPageNumber()"
            >
        </mat-paginator>
      </div>
    
      <table class="assignment-table" mat-table [dataSource]="assignments" matSort (matSortChange)="changeSort($event)">
        <ng-container matColumnDef="patientIdentifier">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Identifier </th>
          <td id="pId{{assignment.bulkSubscriptionAssignmentId}}" mat-cell (click)="onEdit(assignment)" *matCellDef="let assignment"> {{sanitizeIdentifier(assignment.patientIdentifier)}} </td>
        </ng-container>
        <ng-container matColumnDef="friendlyName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
          <td mat-cell id="fnm{{assignment.bulkSubscriptionAssignmentId}}"  (click)="onEdit(assignment)"  *matCellDef="let assignment"> {{getPatientName(assignment)}} </td>
        </ng-container>
        <ng-container matColumnDef="assessmentTaker">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Assessment Taker </th>
          <td mat-cell id="at{{assignment.bulkSubscriptionAssignmentId}}"  (click)="onEdit(assignment)"  *matCellDef="let assignment"> {{getAssessmentTakerIdentifier(assignment)}} </td>
        </ng-container>
        <ng-container matColumnDef="recommendation">
          <th  mat-header-cell *matHeaderCellDef mat-sort-header> <span *ngIf="compass && !compass.promis">Recommendation</span> <span *ngIf="compass && compass.promis">Range</span></th>
          <td mat-cell id="rec{{assignment.bulkSubscriptionAssignmentId}}" (click)="onEdit(assignment)"   *matCellDef="let assignment"> {{getScoreRecommendation(assignment)}} </td>
        </ng-container>
        <ng-container matColumnDef="score">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Score </th>
          <td mat-cell id="sc{{assignment.bulkSubscriptionAssignmentId}}"  (click)="onEdit(assignment)"   *matCellDef="let assignment"> {{getScoreValue(assignment)}} </td>
        </ng-container>
        <ng-container matColumnDef="scoreDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Score Date </th>
          <td mat-cell id="scDt{{assignment.bulkSubscriptionAssignmentId}}"  (click)="onEdit(assignment)"  *matCellDef="let assignment"> {{assignment.scoreDate | date:'shortDate'}} </td>
        </ng-container>
        <ng-container matColumnDef="subjectScoreLevel">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Subject Score Level </th>
          <td mat-cell id="scLvl{{assignment.bulkSubscriptionAssignmentId}}"  (click)="onEdit(assignment)"   *matCellDef="let assignment"> {{assignment.subjectScoreLevel | titlecase}} </td>
        </ng-container>
        <ng-container matColumnDef="assignedBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Assigned By </th>
          <td mat-cell id="aB{{assignment.bulkSubscriptionAssignmentId}}"   (click)="onEdit(assignment)"   *matCellDef="let assignment"> {{assignment.assignedBy}} </td>
        </ng-container>
        <ng-container matColumnDef="assignedDt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Assigned Date </th>
          <td mat-cell id="aDt{{assignment.bulkSubscriptionAssignmentId}}"  (click)="onEdit(assignment)"   *matCellDef="let assignment"> {{assignment.assignedDt | date:'shortDate'}} </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td class="action-bar" id="ab{{assignment.bulkSubscriptionAssignmentId}}"  mat-cell *matCellDef="let assignment">
            <mat-icon id="abI1{{assignment.bulkSubscriptionAssignmentId}}"  class="action-icon" (click)="onEdit(assignment)" *ngIf="!assignment.scoreDate" svgIcon="edit"></mat-icon>
            <mat-icon id="abI2{{assignment.bulkSubscriptionAssignmentId}}" class="action-icon" (click)="onDelete(assignment)" *ngIf="!assignment.scoreDate" svgIcon="delete"></mat-icon>
            <mat-icon id="abI3{{assignment.bulkSubscriptionAssignmentId}}" class="action-icon" (click)="gotoPatient(assignment)" *ngIf="assignment.scoreDate" svgIcon="patient"></mat-icon>
            <mat-icon id="abI4{{assignment.bulkSubscriptionAssignmentId}}" class="action-icon" (click)="gotoReport(assignment)" *ngIf="assignment.scoreDate" svgIcon="report"></mat-icon>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr id="row{{i}}" mat-row *matRowDef="let row; columns: displayedColumns; let i = index"></tr>
      </table>
      <div class="add-new-container">
        <button mat-fab color="primary" [disabled]="!compass" (click)="onAdd()">
      + Add new
        </button>
      </div>
    </div>
    <div *ngIf="tabIndex === 1 && compass && provider" class="fields">
      <alert-definitions  [compass]="compass" [provider]="provider"></alert-definitions>
    </div>
    <div *ngIf="tabIndex === 2" class="fields">
      <compass-summary-chart  [summary]="summary"></compass-summary-chart>
    </div>
  </div>
</div>
